import digitalData from 'digital-data';
import { isDuplicatePageError, isDuplicateEventError, pathToPageSection } from '../thd-analytics-utils';
import {
  ERROR,
  POST_PAGE_ERROR
} from '../constants';

export const splitTypePage = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('splitTypePage.advisory-message', ({ output }) => {
    const { message = '' } = output || {};

    const pageError = {
      type: 'advisory',
      displayType: 'page',
      pageSection: 'scheduled delivery',
      message,
      code: 'n/a',
    };

    digitalData.page = digitalData.page || {};
    digitalData.page.error = digitalData.page.error || [];
    if (!isDuplicatePageError(digitalData, pageError)) {
      digitalData.page.error.push(pageError);
    }
  });
};

export const splitTypeEvent = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('splitTypeEvent.advisory-message', ({ output }) => {
    const { message = '' } = output || {};
    const pageErrors = [];
    const errorDetails = {
      type: 'advisory',
      displayType: 'inline',
      pageSection: 'checkout',
      message,
      code: 'n/a'
    };
    pageErrors.push(errorDetails);

    const ddoEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: POST_PAGE_ERROR,
        error: pageErrors
      }
    };
    digitalData.event = digitalData.event || [];
    if (!isDuplicateEventError(digitalData, pageErrors)) {
      digitalData.event.push(ddoEvent);
    }
  });
};